import { z } from 'zod'
import { ActorNameSchema, FileRefSchema } from '@/shared/lib'

// Встреча, заведённая в deal. Живёт на проекте (project_id) или прямо на
// компании (project_id null, company_id всегда) — форма как у счёта. url —
// ссылка на внешнюю встречу (зум и любой другой сервис), customer_visible —
// пометка «видно заказчику».
//
// Встреча из телемоста живёт в источнике (stit-telemost): править и удалять её
// здесь нельзя, в ленту она приезжает узким видом — её схема лежит рядом с
// лентой, в `widgets/meeting-list`.

export const MeetingSchema = z.object({
  id: z.string(),
  project_id: z.string().nullish(),
  company_id: z.string(),
  title: z.string(),
  when: z.string(),
  location: z.string().optional(),
  participants: z.string().optional(),
  url: z.string().optional(),
  notes: z.string().optional(),
  customer_visible: z.boolean().optional().default(false),
  // Пустой список у huma приезжает и как [], и как null.
  attachments: z
    .array(FileRefSchema)
    .nullish()
    .transform((v) => v ?? []),
  created_by: ActorNameSchema,
  // Имя автора резолвится только на карточке встречи (read-view бэкенда).
  created_by_name: z.string().optional(),
  // Теги — employee-only.
  tags: z.array(z.string()).optional(),
  version: z.number().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
})
export type Meeting = z.infer<typeof MeetingSchema>
